import { jsx as _jsx } from "react/jsx-runtime";
import styles from './Tailspin.scss';
export default function Tailspin({ size = 40, color = 'black', speed = 0.9, stroke = 5, }) {
    return (_jsx("div", { className: styles.container, style: {
            '--uib-size': size + 'px',
            '--uib-color': color,
            '--uib-speed': speed + 's',
            '--uib-stroke': stroke + 'px',
        }, children: _jsx("div", { className: styles.inner }) }));
}
